import { useMutation } from "react-query";
import { updateHierarchy } from "actions/CarrierAgreementMgmt/Hierarchy";
const useUpdateHierarchy = () => {
  return useMutation(updateHierarchy);
};
export default useUpdateHierarchy;
